import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../services/api";
import { ENDPOINTS } from "../../services/endpoints";

const CmsPageComponent: React.FC = () => {
  const [pagedata, setPagedata] = useState<any>({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  // Maps URL paths to their CMS page_shortname when the auto-conversion
  // (hyphen → underscore) doesn't match the stored shortname.
  const PAGE_MAP: Record<string, string> = {
    "terms-of-use": "terms_condition",
  };

  const getPageName = () => {
    const path = location.pathname.replace("/", "");
    if (PAGE_MAP[path]) {
      return PAGE_MAP[path];
    }
    // Default: "/contact-us" → "contact_us", "/privacy-policy" → "privacy_policy"
    return path.replace(/-/g, "_");
  };

  const pageName = getPageName();

  const fetchCms = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await api.post(ENDPOINTS.CMS.PAGES, {
        page_shortname: pageName,
      });
      const result = response.data;
      console.log("CMS API Response:", result);
      if (result.code === 200 && result.data.length > 0) {
        setPagedata(result.data[0]);
        setError("");
      } else {
        setError("Page not found");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [pageName]);

  useEffect(() => {
    if (pageName) {
      fetchCms();
    }
  }, [fetchCms, pageName]);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-danger text-center mt-5">{error}</div>;
  }

  return (
    <div className="container cms-wrapper mt-4">
      {pagedata?.cms_content ? (
        <div
          dangerouslySetInnerHTML={{
            __html: pagedata.cms_content,
          }}
        />
      ) : (
        <div className="text-center">No content available for this page.</div>
      )}
    </div>
  );
};

export default CmsPageComponent;